import { parseAsInteger, useQueryState } from 'nuqs';
import { useDeferredValue, useMemo } from 'react';
import { defaultSorting } from '@/features/purchase-orders/hooks/use-purchase-orders-table';
import { getFiltersStateParser, getSortingStateParser } from '@/lib/parsers';
import { useGetPurchaseOrders } from '@/services/apis/queries/purchase-orders/use-get-purchase-orders';
import type { PurchaseOrder } from '@/types/core/purchase-order/purchase-order';

export const usePurchaseOrdersQuery = () => {
  const [page] = useQueryState('page', parseAsInteger.withDefault(1));
  const [perPage] = useQueryState('perPage', parseAsInteger.withDefault(10));
  const [sort] = useQueryState(
    'sort',
    getSortingStateParser<PurchaseOrder>().withDefault(defaultSorting),
  );
  const [filters] = useQueryState(
    'filters',
    getFiltersStateParser<PurchaseOrder>().withDefault([]),
  );
  const queryParams = useMemo(
    () => ({ page, perPage, sort, filters }),
    [page, perPage, sort, filters],
  );
  const deferredParams = useDeferredValue(queryParams);
  const isPending = queryParams !== deferredParams;

  const { data: purchaseOrders } = useGetPurchaseOrders(deferredParams);

  return {
    isPending,
    purchaseOrders,
  };
};
